// Branded "forgot password" — enter your email, we send a reset link. The API always answers the
// same way (it never reveals whether an email has an account), so this screen shows one confirmation
// regardless. From here the user follows the emailed link to /reset-password/<token>.
import { html, signal, navigate } from '../shared/t4.js';
import { api } from '../shared/api.js';
import { theme, toggleTheme } from '../shared/theme.js';
import { icon } from '../shared/icons.js';

export function forgotScreen(){
  const email   = signal('');
  const sent    = signal(false);
  const loading = signal(false);
  const error   = signal('');

  async function submit(e){
    e.preventDefault();
    loading.value = true; error.value = '';
    try {
      // the side the user came from (Companies / Admin) — lets the API reset in the right realm
      // when an email exists in both; absent is fine (the API then searches both realms).
      let surface = null;
      try { surface = sessionStorage.getItem('sleek_forgot_surface') || null; } catch { /* storage blocked */ }
      await api.post('/auth/forgot-password',
        surface ? { email: email.value.trim(), surface } : { email: email.value.trim() });
      sent.value = true;
    } catch(err){
      error.value = (err.data && err.data.error) || err.message || 'Something went wrong';
    }
    loading.value = false;
  }

  const form = () => html`
    <form class="login-card card" @submit=${submit}>
      <div class="card-body">
        <div class="brand-lockup">
          <span class="brand-dot"></span><span class="brand-name">aboo</span><span class="brand-sub">admin</span>
        </div>
        <h1 class="login-title">Forgot password</h1>
        <p class="login-hint mb-4">Enter your email and we'll send you a link to set a new password.</p>

        <label class="form-label">Email</label>
        <input class="form-control mb-3" type="email" autocomplete="email" placeholder="you@company.co.za"
               .value=${email} @input=${e => { email.value = e.target.value; }}>

        ${() => error.value ? html`<div class="alert alert-danger py-2 mb-3">${error}</div>` : null}

        <button class="btn btn-primary btn-block" type="submit"
                ?disabled=${() => loading.value || !email.value.trim()}>
          ${() => loading.value ? 'Sending…' : 'Send reset link'}
        </button>
        <p class="login-alt mt-3"><a @click=${() => navigate('/login')}>← Back to sign in</a></p>
      </div>
    </form>`;

  const done = () => html`
    <div class="login-card card">
      <div class="card-body signup-done">
        <div class="brand-lockup"><span class="brand-dot"></span><span class="brand-name">aboo</span></div>
        <div class="signup-tick">✓</div>
        <h1 class="login-title">Check your email</h1>
        <p class="login-hint mb-4">If <b>${() => email.value.trim()}</b> has an account, a reset link is on its
          way. The link expires in 1 hour. Didn't get it? Check spam, or try again.</p>
        <button class="btn btn-primary btn-block" @click=${() => navigate('/login')}>Back to sign in</button>
      </div>
    </div>`;

  return html`
    <div class="login-wrap">
      <button type="button" class="theme-toggle login-toggle" title="Toggle light / dark"
              @click=${() => toggleTheme()}>${() => theme.value === 'dark' ? icon('sun', {size: 18}) : icon('moon', {size: 18})}</button>
      ${() => sent.value ? done() : form()}
    </div>`;
}
